// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}

.src-containers-Profile-Settings-styles--attention--bVJHm {
  background: #fffdde;
  border: 1px solid #e8eaf0;
  border: 1px solid var(--lightGrayBlue);
  border-radius: 1px;
  padding: 15px;
  margin-top: 15px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.src-containers-Profile-Settings-styles--attention--bVJHm a {
  width: calc(100% - 25px);
  margin-left: 5px;
  color: #6674a6;
  color: var(--greyishBlue);
  font-size: 14px;
  line-height: 20px;
}

@media screen and (min-width: 768px) {

.src-containers-Profile-Settings-styles--attention--bVJHm a {
    margin-left: 10px;
    font-size: 13px;
    line-height: 15px;
}
  }
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/containers/Profile/Settings/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;ACpBA;EACE,mBAAmB;EACnB,yBAAsC;EAAtC,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,cAAyB;EAAzB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AAOnB;;AALE;;AAPF;IAQI,iBAAiB;IACjB,eAAe;IACf,iBAAiB;AAErB;EADE","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import 'utils/variables.css';\n\n.attention {\n  background: #fffdde;\n  border: 1px solid var(--lightGrayBlue);\n  border-radius: 1px;\n  padding: 15px;\n  margin-top: 15px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n.attention a {\n  width: calc(100% - 25px);\n  margin-left: 5px;\n  color: var(--greyishBlue);\n  font-size: 14px;\n  line-height: 20px;\n\n  @media (--desktop) {\n    margin-left: 10px;\n    font-size: 13px;\n    line-height: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"attention": `src-containers-Profile-Settings-styles--attention--bVJHm`
};
module.exports = ___CSS_LOADER_EXPORT___;
